import { fields, patients } from '@zipdrug/react-api-sdk';
import { alertOnError } from '@zipdrug/ui';
import { pick } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import AddressList from './AddressList';

const sanitizeAddresses = addresses =>
  addresses.slice(0).map(address => pick(address, ...fields.AddressModifier));

function AddressListContainer({ mutateUpdatePatient, patient, ...props }) {
  const onUpdateAddressOrder = useCallback(
    async ({ direction, order }) => {
      const newOrder = order - direction;
      const addresses = sanitizeAddresses(patient.addresses);
      if (newOrder < 0 || newOrder >= addresses.length) return;
      const currentAddress = addresses[order];
      const replaceAddress = addresses[newOrder];
      addresses[newOrder] = currentAddress;
      addresses[order] = replaceAddress;
      await alertOnError(
        mutateUpdatePatient({
          variables: {
            id: patient.id,
            modifier: { addresses },
          },
        }),
      );
    },
    [mutateUpdatePatient, patient],
  );

  return <AddressList {...props} onUpdateAddressOrder={onUpdateAddressOrder} patient={patient} />;
}

AddressListContainer.propTypes = {
  onUpdateAddressOrder: PropTypes.func,
  mutateUpdatePatient: PropTypes.func,
  patient: PropTypes.object,
};

export default graphql(patients.mutateUpdatePatient, { name: 'mutateUpdatePatient' })(
  AddressListContainer,
);
